import { Grid, type GridProps } from '@chakra-ui/react'

const NUM_COLUMNS = 12
const COLUMN_GAP = { base: '16px', md: '24px', lg: '32px' }
const ROW_GAP = { base: '16px', md: '24px', lg: '32px' }

export default function ShwGrid({
  children,
  ...gridProps
}: {
  children: React.ReactNode
  columnGap?: GridProps['columnGap']
  rowGap?: GridProps['rowGap']
} & GridProps): JSX.Element {
  return (
    <Grid
      templateColumns={`repeat(${NUM_COLUMNS}, 1fr)`}
      columnGap={COLUMN_GAP}
      rowGap={ROW_GAP}
      {...gridProps}
    >
      {children}
    </Grid>
  )
}
